<template>
  <div class="resources-web">
    <div class="box">
      <p class="title" id="News">{{$t('resources.news')}}</p>
      <p class="des">{{$t('resources.des1')}}</p>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article0">
            <img src="../assets/resources-web/0.png" />
            <p class="content">{{$t('article0.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article1">
            <img src="../assets/resources-web/1.png" />
            <p class="content">{{$t('article1.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article2">
            <img src="../assets/resources-web/2.png" />
            <p class="content">{{$t('article2.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article3">
            <img src="../assets/resources-web/3.png" />
            <p class="content">{{$t('article3.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article4">
            <img src="../assets/resources-web/4.png" />
            <p class="content">{{$t('article4.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article5">
            <img src="../assets/resources-web/5.png" />
            <p class="content">{{$t('article5.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article6">
            <img src="../assets/resources-web/6.png" />
            <p class="content">{{$t('article6.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article7">
            <img src="../assets/resources-web/7.png" />
            <p class="content">{{$t('article7.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article8">
            <img src="../assets/resources-web/8.png" />
            <p class="content">{{$t('article8.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article17">
            <img src="../assets/resources-web/17.png" />
            <p class="content">{{$t('article17.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article18">
            <img src="../assets/article/18 RedteaGO Global eSIM Plan.png" />
            <p class="content">{{$t('article18.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;"></Col>
        <Col span="8" style="padding-right:0.2rem;"></Col>
      </Row>
    </div>

    <div class="box">
      <p class="title" id="Industry">{{$t('resources.report')}}</p>
      <p class="des">{{$t('resources.des2')}}</p>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article9">
            <img src="../assets/resources-web/9.png" />
            <p class="content">{{$t('article9.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article10">
            <img src="../assets/resources-web/10.png" />
            <p class="content">{{$t('article10.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article11">
            <img src="../assets/resources-web/11.png" />
            <p class="content">{{$t('article11.title')}}</p>
          </router-link>
        </Col>
      </Row>
    </div>

    <div class="box">
      <p class="title" id="Insights">{{$t('resources.Insights')}}</p>
      <p class="des">{{$t('resources.des3')}}</p>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article12">
            <img src="../assets/resources-web/12.png" />
            <p class="content">{{$t('article12.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article13">
            <img src="../assets/resources-web/13.png" />
            <p class="content">{{$t('article13.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article14">
            <img src="../assets/resources-web/14.png" />
            <p class="content">{{$t('article14.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article15">
            <img src="../assets/resources-web/15.png" />
            <p class="content">{{$t('article15.title')}}</p>
          </router-link>
        </Col>
        <Col span="8" style="padding-right:0.2rem;">
          <router-link target="_blank" to="article16">
            <img src="../assets/resources-web/16.png" />
            <p class="content">{{$t('article16.title')}}</p>
          </router-link>
        </Col>
        <Col span="8"></Col>
      </Row>
    </div>

    <div class="box">
      <p class="title" id="Terms">{{$t('resources.terms')}}</p>
      <p class="des">{{$t('resources.des4')}}</p>
      <div style="display:flex;justify-content:center;align-items:center;cursor:pointer;">
        <img src="../assets/resources-web/下载.svg" style="width:30px;margin-right:10px;" />
        <span class="content" style="margin-top:6px;">{{$t('resources.download')}}</span>
      </div>
    </div>

    <div class="box">
      <p class="title" id="FAQ">{{$t('resources.FAQ')}}</p>
      <p class="des">{{$t('resources.FAQdes')}}</p>
      <div style="display:flex;justify-content:center;align-items:center;cursor:pointer;">
        <img src="../assets/resources-web/下载.svg" style="width:30px;margin-right:10px;" />
        <span class="content" style="margin-top:6px;">{{$t('resources.download')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resources-web',
  components: {}
}
</script>
<style lang="less" scoped>
.resources-web {
  padding-bottom: 3.45rem;
  .box {
    width: 11.8rem;
    margin: auto;
    padding-top: 1rem;
  }
  .title {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-Light';
    font-size: 0.35rem;
    margin-bottom: 0.2rem;
  }
  .des {
    color: rgba(32, 49, 82, 0.8);
    font-family: 'Poppins-Light';
    font-size: 16px;
    text-align: left;
  }
  .content {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-Light';
    font-size: 14px;
    text-align: left;
  }
  img {
    // width: 3.8rem;
    margin-top: 0.26rem;
    margin-bottom: 0.2rem;
  }
}
</style>
